define.alias("shared/components/shared/date-picker", "settings/components/shared/date-picker");